import { FC } from 'react'
import { Outlet } from 'react-router-dom'
import { GuestsDataProvider } from 'components/common/MarchPromo/utils/guestsDataProvider'

export const GuestDataWrapper: FC = ({ children }) => (
    <GuestsDataProvider>
        <Outlet />
    </GuestsDataProvider>
)
